import { useQuery } from '@tanstack/react-query';
import { useTenantContext } from 'src/context/useTenantContext';
import { tenantMenuItemVariants } from 'src/services/apis/tenantRequests';
import { QUERIES } from 'src/utils/react-query';

export const useMenuItemVariants = () => {
  const { orgSlug, restaurantId } = useTenantContext();
  return useQuery([QUERIES.MENU_ITEM_VARIANTS, orgSlug, restaurantId], () =>
    tenantMenuItemVariants({ orgSlug, restaurantId })
  );
};
